<template>
  <div class="im-chat">
    <div style="display: none;" class="im-chat-top" v-if="currentSession">
      <span>{{ currentSession.title }}</span>
      <a href="javascript:;" @click="modal = true" class="pull-right menu">
        <Icon type="md-menu" />
      </a>
    </div>
    <div class="im-chat-main">
      <div class="im-chat-main-left">
        
        <div ref="messageBox" class="messages" id="message-box">
          <div v-for="(message, i) in messageData" :key="i">
            <div :id="'sellerchat_'+i" v-show="i == currentStore.seller_id && currentSession">
              <Scroll ref="chatScroll" :height="messageScroll" :on-reach-top="handleReachTop" :distance-to-edge="-30">
              <ul>
                
                <li
                  v-for="(item, index) in message.message_list"
                  :key="index"
                  :class="{ 'im-chat-mine': item.from_account_type == 2, 'sys-notice': item.sys_notice == 1 }"
                  :id="item.message_id"
                >

                  <div v-if="index > 0 && (item.send_time - message.message_list[index-1].send_time > 3e5)" class="im-chat-time">
                    {{formatDate(item.send_time)}}
                  </div>
                  <div class="im-chat-user">
                    <img v-if="item.from_account_type == 2" :src="item.avatar" alt="头像" />
                    <img v-if="item.from_account_type == 1" :src="error_img" :onload="loadImg(item.avatar)" :onerror="errorImg" alt="头像" />
                    <div class="message-info right" v-if="item.from_account_type == 2">
                      <i >
                        <Time :time="item.send_time" />
                      </i>
                      <font color="#07f" v-if="item.csr != undefined">{{item.csr.username}}</font>
                    </div>
                    <div class="message-info" v-if="item.from_account_type == 1">
                      <span>{{ item.username }}</span>
                      <i >
                        <Time :time="item.send_time" />
                      </i>
                    </div>
                  </div>
                  <div class="chat-content-wrap">
                    <div style="overflow: hidden;" @click="chatItemEvent(item)" class="im-chat-text" :class="{ 'message-card': item.template_id > 100}">
                      <div v-if="item.template_id < 2">
                        <pre
                          v-html="item.format_content"
                          v-on:click="openImageProxy($event)"
                        ></pre>
                        <div v-if="translate && item.trans_result && item.trans_result.zh" style="margin-top: 10px;" class="trans-wrap">
                          <span style="color: #999; font-size: 12px;" class="trans-desc">译文</span>
                          <div style="display: flex;align-items: center;" class="trans-text-wrap">
                            <span style="width: 2px; height: 16px; background: rgb(254 219 113);display: inline-block;margin-right: 10px;"></span>
                            <span>
                              {{item.trans_result.zh}}
                            </span>
                          </div>
                        </div>

                      </div>
                      <div v-else-if="item.template_id >= 2">
                        <div v-html="item.format_content"></div>
                      </div>
                      
                    </div>
                    <div v-if="item.from_account_type == 2" class="chat-content-loading">                    
                      <Icon v-if="item.message_id.indexOf('sending') > -1" style="animation: ani-demo-spin 1s linear infinite;" type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                      <Icon v-if="item.message_id.indexOf('error') > -1" color="#ff0000" type="md-alert" size=18 class="demo-spin-icon-load"></Icon>
                    </div>
                  </div>
                </li>
              </ul>
              </Scroll>
              <Spin size="large" fix v-if="chatLoader"></Spin>
            </div>
          </div>
        </div>

        <div class="im-chat-footer">
          <div style="margin-left: -1rem;" class="im-chat-tool">
            
            <Faces title="表情" @sendComplete="sendComplete"></Faces>
            <upload-tool title="上传图片" @uploadback="uploadback"></upload-tool>
            <UploadVideo title="上传视频" @uploadCallback="videoUploadCallback"></UploadVideo>
            <dialogue-tool title="知识快捷回复" @uploadback="uploadback" @updatemessagecon="updateMessageCon"></dialogue-tool>
            <LazadaDialogue title="lazada快捷回复" @updatemessagecon="updateMessageCon"></LazadaDialogue>
            <translate-tool title="翻译"></translate-tool>
            
            <Button v-if="false" class="history-message-btn" @click="history"
              >聊天记录</Button
            >
          </div>
          <textarea
            @keydown="handleKeyDown"
            ref="msgInput"
            v-model="messageContent"
            class="textarea"
            @keydown.enter="mineSend"
            @paste="onPaste"
            placeholder="回车发送消息，Ctrl + Enter键换行"
          ></textarea>
          <div v-if="translate" style="padding: 0.5rem;">
            <div style="display: flex;align-items: center;">
              <div v-if="!translantLoading" style="font-size: 12px; color: rgb(208 208 208); width: 80px;">翻译</div>
              <div v-if="translantLoading" style="font-size: 12px; color: rgb(208 208 208); width: 80px;display: flex;align-items: center;">
                <span style="margin-right: 5px;">翻译中</span>
                <Spin>
                    <Icon type="ios-loading" size=18 class="spin-icon-load"></Icon>
                </Spin>
              </div>
              <div style="width: 100%;border-top: 1px dashed rgb(208 208 208);"></div>
            </div>
            <textarea v-model="messageContentTrans" style="height: 40px;"></textarea>
          </div>
          <div class="im-chat-send">
            <Button @click="translantText" style="margin-right: 5px;">翻译</Button>
            <ButtonGroup>
              <Button type="primary" @click="mineSend()">发送</Button>
              <Dropdown placement="top-start" trigger="click">
                <Button style="border-radius: 0px 4px 4px 0px;
    border-left: 1px solid #ffffff8a;
    padding: 0px 8px;" type="primary">
                    <Icon type="ios-arrow-down"></Icon>
                </Button>
                  <template #list>
                      <DropdownMenu>
                          <DropdownItem>
                            <div @click="setSendBefore('')">
                              直接发送
                              <Icon v-if="sendBefore === ''" color="#2b85e4" size="20" type="md-checkmark" />  
                            </div>
                          </DropdownItem>
                          <DropdownItem>
                            <div @click="setSendBefore('translate')">
                            翻译后发送
                            <Icon v-if="sendBefore === 'translate'" color="#2b85e4" size="20" type="md-checkmark" />
                            </div>
                          </DropdownItem>
                      </DropdownMenu>
                  </template>
              </Dropdown>  
            </ButtonGroup>
            
          </div>

        </div>

        <div v-show="!currentSession" class="chat-shade">
          <div class="portal-bg">
            <div class="portal-text">
              <h3 data-spm-anchor-id="a1zawg.15103027.0.i2.4cf24edfcmQGQg">
                <font style="vertical-align: inherit;">
                  <font data-spm-anchor-id="a1zawg.15103027.0.i4.4cf24edfcmQGQg" style="vertical-align: inherit;">全新的消息工作站终于来了！</font></font>
              </h3>
              <p data-spm-anchor-id="a1zawg.15103027.0.i1.4cf24edfcmQGQg">
                <font style="vertical-align: inherit;">
                  <font data-spm-anchor-id="a1zawg.15103027.0.i5.4cf24edfcmQGQg" style="vertical-align: inherit;">以更有效的方式与客户交谈，以帮助您的业务更快发展！</font></font>
              </p>
            </div>
            <div class="portal-image">
              <img src="~@/static/img/chat-bg.png"></div>
          </div>
        </div>
      </div>

    </div>
    

    <Drawer
      title="聊天记录"
      :closable="true"
      v-model="showHistory"
      class="history-message"
      width="60%"
    >
      <history-message
        :showHistory="showHistory"
        :chat="chat"
      ></history-message>
    </Drawer>
<Modal
    v-model="videoModal"
    title="video"
    :footer-hide="true"
    @on-cancel="videoModal = false">
    <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
</Modal>
  </div>
</template>


<script>
import conf from "../../conf";
import Faces from "./faces.vue";
import UploadTool from "./uploadTool.vue";
// import VideoTool from "./videoTool.vue";
import DialogueTool from "../common/dialogueTool.vue";
import TranslateTool from "../common/translateTool.vue";
import LazadaDialogue from "./dialogueTool.vue";
import HistoryMessage from "./historyMessage.vue";
import UploadVideo from "./uploadVideo.vue";
import EventBus from "@/utils/eventBus";
import RequestUtils from "@/utils/RequestUtils";
import MsgUtils from '@/utils/MsgUtils';
import { scrollBottom, formatDateTime } from "@/utils/ChatUtils";

export default {
  components: {
    Faces,
    HistoryMessage,
    UploadTool,
    DialogueTool,
    LazadaDialogue,
    TranslateTool,
    UploadVideo,
    // VideoTool
  },
  name: "userChat",
  computed: {
    errorImg: function() {
      return 'this.onload=null;this.src='+'"'+this.error_img+'";';
    },
    translate: {
      get: function () {
        return this.$store.state.translate;
      }
    },
    sendBefore: {
      get: function () {
        return this.$store.state.sendBefore;
      }
    },
    currentSession: {
      get: function() {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        return this.$store.state.lazada.currentSessionData[seller_id];
      }
    },
    messageData: {
      get: function () {
        return this.$store.state.lazada.messageData;
      }
    },
    message: {
      get: function () {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        return this.$store.state.lazada.messageData[seller_id];
      }
    },
    currentStore: {
      get: function () {
        return this.$store.state.lazada.currentStore;
      }
    },
    chatBoxElem: {
      get: function () {
        let seller_id = this.$store.state.lazada.currentStore.seller_id;
        return document.getElementById('sellerchat_'+seller_id).querySelector('.ivu-scroll-content');
      }
    }
  },
  data() {
    return {
      error_img: require("../../../../static/img/default_avatar.png"),
      loadImg: (imgSrc) => {
        return 'this.onload=null;this.src='+'"'+imgSrc+'";';
      },
      host: conf.getHostUrl(),
      count: 0,
      pageSize: 20,
      modal: false,
      videoModal: false,
      // 保存各个聊天记录的map
      messageListMap: new Map(),
      messageContent: "",
      messageContentTrans: "",
      showHistory: false,
      userList: [],
      chatLoader: false,
      messageScroll: 500,
      knowledgeMsg: {},
      videoContent: {},
      translantLoading: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: '', //url地址
          },
        ],
        poster: '', //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      lastTime: null
    };
  },
  props: ["chat"],
  methods: {
    setSendBefore(val) {
      this.$store.commit('setSendBefore', val);
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        if (event.ctrlKey) {
          this.messageContent += "\n";
        }
        event.preventDefault();
      }
    },
    // 粘贴截图
    onPaste(e) {
      let self = this;
      if ( !(e.clipboardData && e.clipboardData.items) ) {
          return;
      }
      for (let i = 0, len = e.clipboardData.items.length; i < len; i++) {
          let item = e.clipboardData.items[i];
          if (item.kind === "file") {
              let f= item.getAsFile();
              let reader=new FileReader()
              reader.onload=function (e) {
                  let img=document.createElement('img') //创建img节点
                  img.src=e.target.result //设置img的src属性

                  let param = new FormData();
                  param.set("baseimg", img.src);

                  RequestUtils.request(conf.commonUpload(), param)
                  .then(json => {
                    self.uploadback(json);
                  })                  
              }
              reader.readAsDataURL(f)
          }
      }
    },
    formatDate(timestamp) {
      return formatDateTime(new Date(timestamp*1), 'YYYY/mm/dd HH:MM');
    },
    handleReachTop () {
      let self = this;
      if (!self.message.has_more) {
        document.getElementById('sellerchat_'+this.currentStore.seller_id).getElementsByClassName('ivu-scroll-loader')[0].style.display = 'none';
        return false;
      }
      // let Viewid = this.message.message_list[0].message_id;
      return new Promise(resolve => {
        let param = new FormData();
        param.set("store_id", self.currentStore.id);
        param.set("session_id", self.currentSession.session_id);
        param.set("last_message_id", self.message.last_message_id);
        param.set("next_start_time", self.message.next_start_time);
        param.set("connector", 'lazada');

        RequestUtils.request(conf.getMessages(), param).then(json => {
          json.message_list = json.message_list.reverse();
          this.$store.commit("lazada/pushMessageList", json);
          // document.getElementById(Viewid).scrollIntoView(true);
          document.getElementById('sellerchat_'+this.currentStore.seller_id).getElementsByClassName('ivu-scroll-loader')[0].style.display = 'block';
        })

        resolve();
      });
    },
    history() {
      this.showHistory = !this.showHistory;
    },
    uploadback(data) {
      this.$emit('previewshow', data);
    },
    videoUploadCallback(data) {
      this.videoSend(data);
    },
    /**
     * 消息事件
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    chatItemEvent: function(item) {
      let self = this;
      if (item.template_id == 3) {
        this.$emit('emitPreviewImg', JSON.parse(item.content));
      } else if (item.template_id == 6) {
        this.$Spin.show({
            render: (h) => {
                return h('div', [
                    h('Icon', {
                        'class': 'spin-icon-load',
                        props: {
                            type: 'ios-loading',
                            size: 18
                        }
                    }),
                    h('div', '获取视频中...')
                ])
            }
        });
        let chatContent = JSON.parse(item.content);
        let param = new FormData();
        param.set("store_id", this.currentStore.id);
        param.set("videoId", chatContent.videoId);

        RequestUtils.request(conf.getVideo(), param)
        .then(json => {
          this.$Spin.hide();
          self.videoModal = true;
          self.videoContent = json;
          self.playerOptions.poster = json.cover_url;
          self.playerOptions.sources[0].src = json.video_url;
          self.$refs.videoPlayer.player.play() // 播放
        })
      }
    },
    sendComplete: function() {
      scrollBottom(this, this.chatBoxElem);
    },
    updateMessageCon(content) {
      this.messageContent = content;
    },
    
    /**
     * 翻译文本
     * @return {[type]} [description]
     */
    translantText(callback) {
      this.translantLoading = true;
      let param = new FormData();
      param.set("querys", JSON.stringify([{"src": this.messageContent}]));
      param.set("to", this.translate);
      if (callback) {
        this.messageContent = '';
      }

      RequestUtils.request(conf.translantText(), param)
      .then(json => {
        this.translantLoading = false;
        this.messageContentTrans = json.trans_result[0]['dst'];
        callback && callback();
      })
    },
    /**
     * 发送文本消息模板
     * @return {[type]} [description]
     */
    mineSend(event) {
      if (event && event.ctrlKey) {
        return false;
      }
      let isExpiredSession = true;
      let newTime = (new Date()).getTime();
      for (let i=this.message.message_list.length-1; i>0; i--) {
        if (this.message.message_list[i].from_account_type == 1) {        
          if (newTime - this.message.message_list[i].send_time > 5*24*3600*1000) {
            isExpiredSession = true;
            break;
          } else {
            isExpiredSession = false;
            break;
          }
        }
      }
      let self = this;
      let param = new FormData();
      let messageContent = this.messageContentTrans ? this.messageContentTrans : this.messageContent;
      // if (!messageContent) {
      //   return false;
      // }
      let content = JSON.parse(JSON.stringify({text: messageContent}));
      content.text = content.text.replace(/\[图片\]/g, '');
      if (content.text.trim() != '') {
        param.set("store_id", self.currentStore.id);
        param.set("session_id", self.currentSession.session_id);
        param.set("connector", 'lazada');
        param.set("template_id", 1);
        param.set("txt", content.text);
        param.set("chatExpired", isExpiredSession);
        if (this.translate) {        
          param.set("trans_src", this.messageContent);
        }
        this.messageContent = "";
        this.messageContentTrans = "";
        MsgUtils.request(self, param).then(() => {
          scrollBottom(self, this.chatBoxElem);
        })
      }
      if (this.knowledgeMsg.id) {
        if (this.knowledgeMsg.images.length > 0) {
          for (let i=0; i<this.knowledgeMsg.images.length; i++) {
            this.imageSend(this.knowledgeMsg.images[i]);
          }
        }
        this.knowledgeMsg = {};
      }
    },
    videoSend(data) {
      let self = this;
      let param = new FormData();
      param.set("store_id", this.currentStore.id);
      param.set("session_id", this.currentSession.session_id);
      param.set("connector", 'lazada');
      param.set("template_id", 6);
      param.set("video_id", data.videoId);
      param.set("width", data.width);
      param.set("height", data.height);

      RequestUtils.request(conf.sendMessage(), param)
      .then(json => {
        let message = {
          message_id: json.message_id,
          template_id: 6,
          data: {
            imgUrl: data.coverUrl,
            width: data.width,
            height: data.height,
            videoId: data.videoId,

          }
        };
        self.$store.commit("lazada/addMessage", message);
      })
      this.$emit('previewhide');
    },
    imageSend(data) {
      let self = this;
      let param = new FormData();
      param.set("store_id", this.currentStore.id);
      param.set("session_id", this.currentSession.session_id);
      param.set("connector", 'lazada');
      param.set("template_id", 3);
      param.set("img_url", data.url);
      param.set("width", data.width);
      param.set("height", data.height);

      RequestUtils.request(conf.sendMessage(), param)
      .then(json => {
        let message = {
          message_id: json.message_id,
          template_id: 3,
          data: {
            imgUrl: data.url,
            width: data.width,
            height: data.height,

          }
        };
        self.$store.commit("lazada/addMessage", message);
      })
      this.$emit('previewhide');
    },
    /**
     * 获取历史消息
     * @return {[type]} [description]
     */
    getHistoryMessage() {
      let self = this;
      let param = new FormData();
      param.set("store_id", self.currentStore.id);
      param.set("session_id", self.currentSession.session_id);
      param.set("connector", 'lazada');

      this.chatLoader = true;
      RequestUtils.request(conf.getMessages(), param).then(json => {

        json.message_list = json.message_list.reverse();
        self.$store.commit("lazada/setMessageData", json);
        // 每次滚动到最底部
        scrollBottom(self, this.chatBoxElem);
        self.chatLoader = false;
        
        if (self.currentSession.unread_count > 0) {
          self.$store.commit("lazada/readSession");
        }
        self.$store.commit("lazada/updateTransferMark");
      });
    },
    copyToChat(data) {
      this.messageContent = data.formatText;
      this.knowledgeMsg = data;
      this.$refs.msgInput.focus();
    }
  },
  mounted: function() {
    this.messageScroll = document.querySelector('body').offsetHeight - 64 - 200;
    EventBus.$on('lazadaAddmsgCallback', () => {
      this.sendComplete();
    })
  }
};
</script>

<style lang="scss">
@import "@/static/styles/theme";

.ivu-select-dropdown {
  left: -10px!important;
  .ivu-dropdown-item {
    text-align: left;
  }
}
.spin-col .circular {
    width:25px;
    height:25px;
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}

.background-default {
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  justify-content: space-around;
  align-items: center;
  display: flex;

}

.im-chat {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.im-chat-top {
  border-bottom: 1px solid #cccccc;
  color: $color-default;
  padding: 0 0 0.2rem 1rem;
  font-size: 1.6rem;
  font-weight: bold;
  height: 40px;

  .menu {
    color: $color-default;
    display: inline-block;
    padding: 0 10px;
  }
}

.user-model {
  .user-model-img {
    padding: 15px;
    text-align: center;

    img {
      border-radius: 50%;
    }
  }

  .user-model-item {
    display: flex;
    padding: 5px 0;

    label {
      flex: 2;
      font-weight: bold;
      text-align: right;
    }

    span {
      flex: 3;
    }
  }
}

.im-chat-main {
  flex: 1;
  display: flex;
  flex-direction: row;
  height: calc(100% - 40px);

  .im-chat-main-left {
    flex: 4;
    display: flex;
    flex-direction: column;

    .im-chat-main-box {
      flex: 1;
    }
  }

  .message-img {
    max-width: 20rem;
  }

  .im-chat-users {
    width: 180px;
    border-left: 1px solid #cccccc;
    overflow-y: scroll;

    ::-webkit-scrollbar {
      width: 0;
    }

    .chat-user-list {
      list-style: none;
      margin: 0;

      & > li {
        margin-bottom: 1rem;
        cursor: pointer;
        padding: 5px 2px;
        position: relative;

        &:hover {
          background-color: #eeeeee;

          &:after {
            content: "...";
            position: absolute;
            right: 10px;
            font-weight: bold;
          }
        }

        & > .im-chat-avatar {
          width: 3.2rem;
          height: 3.2rem;
          display: inline-block;
          vertical-align: middle;

          & > img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .messages {
    width: 100%;
    height: calc(100% - 20rem);
    position: relative;

    .chat-shade {
      position: absolute;
    }

    ul {
      width: 100%;
      padding: 0px 1rem;

      li {
        position: relative;
        font-size: 0;
        margin-bottom: 10px;
        padding-left: 60px;
        min-height: 68px;

        .im-chat-text {
          position: relative;
          line-height: 22px;
          margin-top: 25px;
          padding: 1rem;
          background-color: #e2e2e2;
          border-radius: 3px;
          color: #333;
          word-break: break-all;
          display: inline-block;
          vertical-align: top;
          font-size: 14px;
          max-width: 400px;

          &:after {
            content: "";
            position: absolute;
            left: -10px;
            top: 13px;
            width: 0;
            height: 0;
            border-style: solid dashed dashed;
            border-color: #e2e2e2 transparent transparent;
            overflow: hidden;
            border-width: 10px;
          }

          pre {
            width: 100%;
            white-space: pre-wrap;
            word-break: break-all;

            img {
              display: block;
            }
          }
        }
      }
    }

    .chat-content-wrap {
      display: inline-block;
      position: relative;

      .chat-content-loading {
        position: absolute;
        left: -15px;
        top: 54%;
      }
    }

    .im-chat-user {
      width: 4rem;
      height: 4rem;
      position: absolute;
      display: inline-block;
      vertical-align: top;
      font-size: 14px;
      left: 3px;
      right: auto;

      .message-info {
        position: absolute;
        left: 60px;
        top: -2px;
        width: 500px;
        line-height: 24px;
        font-size: 12px;
        white-space: nowrap;
        color: #999;
        text-align: left;
        font-style: normal;

        i {
          font-style: normal;
          padding-left: 15px;
        }
      }

      .right {
        right: 0;
        text-align: right;
        left: auto;

        i {
          padding-right: 15px;
        }
      }

      img {
        width: 4rem;
        height: 4rem;
        border-radius: 100%;
      }
    }

    .sys-notice {
      padding: 0px!important;
      text-align: center!important;

      .im-chat-user {
        display: none;
      }
      .im-chat-text {
        background-color: #f8f8f8!important;
        color: #9299a2!important;
        border: none!important;
        &:after {
          display: none;
        }
      }
    }

    .im-chat-time {
      width: 100%;
      height: 50px;
      color: rgb(146, 153, 162);
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-right: 60px;
    }

    .im-chat-mine {
      text-align: right;
      padding-left: 0;
      padding-right: 60px;

      .im-chat-time {
        padding-left: 60px;
        padding-right: 0px;
      }

      .im-chat-text {
        margin-left: 10px;
        text-align: left;
        color: #fff;
        display: inline-block;
        vertical-align: top;
        font-size: 14px;
        border: .5px solid #a5cbe9;
        background-color: #c9e7ff;
        color: #333;

        &:after {
          left: auto;
          right: -10px;
          border-top-color: #c9e7ff;
        }

      }
      


      .im-chat-user {
        left: auto;
        right: 3px;

        cite {
          left: auto;
          right: 60px;
          text-align: right;

          i {
            padding-left: 0;
            padding-right: 15px;
          }
        }

        .message-info {
          right: 60px !important;
        }
      }
    }

    .message_csr_section {
      text-align: right;        
      font-size: 12px;
      color: #999;
      margin-top: 5px;
      .csr_name {
        color: #07f;
      }
    }

    .message-translate {
        .translation {
          position: relative;
          margin-top: 12px;

          &:before {
            content: " ";
            position: absolute;
            top: -6px;
            left: -4px;
            border-top: 1px solid #e2e2e2;
            height: 1px;
            width: calc(100% + 8px);
          }
        }
        .tip {
          margin-top: 4px;
          margin-bottom: -6px;
          opacity: .5;
          font-size: 10px;
          color: #333;
          letter-spacing: 0;
          text-align: right;
          line-height: 20.15px;
        }
    }

    .message-card {
      width: 255px;
      color: #3a434d!important;
      background: #fff;
      background-color: #fff!important;
      border: .5px solid #eee!important;
      cursor: pointer;
      font-size: 12px!important;


      /*自动回复*/
      .card-action {
        .message-text-box {
          .im-ui-message-text {
            margin-bottom: 15px;
            word-break: break-word;
            word-wrap: break-word;
            max-width: 750px;
            font-size: 14px;
            color: #151515;
            letter-spacing: 0;
            white-space: pre-wrap;
          }
          .im-ui-message-actions {
            font-size: 12px;
            .action-item {
              margin-bottom: 5px;
              .action-link {
                color: #2192D9;
                cursor: pointer;
              }
            }
          }
        }
      }

      .card-order {
        .order-status {
          font-size: 12px;
        }
        .order-content {
          font-size: 12px;
          
        }
      }

      .card-voucher {
        .row.top {
          background: url(https://sg-live-02.slatic.net/original/39b91780e2dad9b1066ad7e51519b9cd.jpg) no-repeat;
          background-size: 100% 100%;
          padding: 10px;
          flex: 1 1;
          overflow: hidden;

          .voucher-type {
            display: flex;
            height: 20px;
            min-height: 20px;
            line-height: 20px;

            .voucher-img {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background-size: contain;
              background-position: 50%;
              background-repeat: no-repeat;
              position: relative;
            }
            .type-name {
              margin-left: 5px;
              font-size: 12px;
              line-height: 20px;
              color: #fff;
              font-style: italic;
              text-transform: capitalize;
            }
          }
          .title {
            margin-top: 5px;
            margin-bottom: 4px;
            height: 32px;
            font-size: 13px;
            line-height: 14px;
          }
          .promotion {
            width: 100%;
            color: #823102;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-pack: justify;
            justify-content: space-between;
            -ms-flex-align: center;
            align-items: center;

            .discount {
              font-size: 22px;
              display: -ms-flexbox;
              display: flex;
              -ms-flex-align: baseline;
              align-items: baseline;
              margin-right: 5px;
              min-width: 0;

              .amount {
                flex: 1 1;
                letter-spacing: 0;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .unit {
                font-size: 14px;
                min-width: 20px;
              }
            }
            .btn {
              height: 24px;
              line-height: 24px;
              width: 65px;
              text-align: center;
              font-size: 12px;
              color: #fff;
              background-image: -webkit-gradient(linear,left top,right top,from(#ff8763),to(#ff330c));
              background-image: linear-gradient(
          90deg,#ff8763,#ff330c);
              border-radius: 2px;
              cursor: pointer;
            }
          }
        }
        .row.bottom {
          background: #ffba27;
          position: relative;
          height: 30px;
          overflow: visible;
          display: -ms-flexbox;
          display: flex;
          padding: 0 10px;

          .period {
            margin-top: 8px;
          }

          &:before {
            left: -8px;
            top: -8px;
            content: " ";
            position: absolute;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background-color: #fff;
          }
          &:after {
            right: -8px;
            top: -8px;
            content: " ";
            position: absolute;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background-color: #fff;
          }
        }

      }

      .card-follow {
        .lzd-follow-img {
          flex-shrink: 0;
          border: 0 solid #e6e7eb;
          width: 60px;
          height: 60px;
          margin-right: 19px;
          background-size: 100% 100%;
        }
        .lzd-follow-desc {
          font-size: 12px;
        }
      }

      .card-refund {
        .flex-column {
          flex-direction: column;
        }
        .lzd-refund-suborder {
          display: flex;
          margin-top: 2px;

          .desc {
            margin-left: 5px;
            overflow: hidden;

            .lzd-refund-suborder-title {
              line-height: 16px;
              margin-bottom: 10px;
              height: 32px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              word-break: break-all;
            }
            .lzd-refund-suborder-desc {
              display: flex;
              justify-content: space-between;
              font-weight: 700;
              .sku {
                color: #979797;
                flex-grow: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .count {
                flex-shrink: 0;
                color: #3a434d;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
        .lzd-refund-suborder-total {
          display: flex;
          margin-top: 5px;
          justify-content: space-between;
          border-bottom: 1px solid #eff2fa;
          padding-bottom: 5px;

          .visibility-hidden {
            visibility: hidden;
          }

          .lzd-suborder-total-desc {
            align-self: flex-end;
            text-align: right;
            line-height: 20px;
            letter-spacing: 0;

            .total-count {
              color: #3a434d;
              font-weight: 700;
            }

            .total-price {
              color: #f54719;
              font-weight: 700;
            }
          }
        }
        .lzd-refund-order-desc {
          margin-top: 6px;
          overflow: hidden;
          padding-bottom: 6px;
          line-height: 20px;
        }
      }

      .card-invite-order {
        .im-ui-header {
          margin-bottom: 8px;

          .im-ui-bargain-icon {
            width: 13px;
            height: 13px;
          }

          .im-ui-header-title {
            height: 20px;
            color: #595f6d;
            font-size: 14px;
            line-height: 20px;
          }
        }
        .im-ui-bargain-content {
          width: 100%;
          padding: 8px 0 0;
          box-sizing: border-box;
          border-top: 1px solid #eee;

          .im-ui-content-product {
            padding: 14px;
            box-sizing: border-box;
            background-color: #f8f8f8;
            border: 1px solid #eee;
            border-radius: 8px;
            .im-ui-pro-img {
              width: 58px;
              height: 56px;
              border: 1px solid #eee;
              border-radius: 4px;
            }
            .im-ui-content-item-name {
              max-height: 32px;
              width: 277px;
              line-height: 16px;
              font-family: Roboto-Regular;
              font-size: 14px;
              color: #111;
              word-break: break-all;
              font-weight: 500;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              overflow: hidden;
              -webkit-box-orient: vertical;
            }
            .im-ui-content-item-attribute {
              min-height: 14px;
              line-height: 14px;
              font-family: Roboto-Regular;
              font-size: 12px;
              color: #858b9c;
              letter-spacing: 0;
            }
            .im-ui-content-price {
              height: 16px;
              line-height: 16px;
              font-family: Roboto-Regular;
              font-weight: 500;
              font-size: 14px;
              color: #fe4f65;
              letter-spacing: 0;
            }
            .im-ui-content-total {
              font-size: 14px;
              color: #000;
              font-weight: 500;
            }
          }
        }
        .im-ui-invite-voucher-price {
          color: #fe4960;
          font-size: 14px;
          font-weight: 500;
        }
        .im-ui-bottom {
          height: 36px;
          .title {
            font-size: 14px;
            color: #000;
          }
          .totalPrice {
            font-size: 14px;
            color: #858b9c;
            text-decoration: line-through;
          }
          .price {
            color: #000;
          }
        }
        .im-ui-bargain-btn {
          height: 48px;
          box-sizing: border-box;
          padding: 8px 0;
        }
        .next-btn.next-btn-secondary {
          border-style: solid;
          background: #fff;
          border-color: #9fb7f9;
          color: #fff;
        }
        .next-btn.next-btn-primary {
          border-style: solid;
          background: #1a71ff;
          border-color: transparent;
          color: #fff;
        }
        .next-btn.next-medium {
          border-radius: 8px;
          padding: 0 12px;
          height: 32px;
          font-size: 14px;
          border-width: 1px;
        }
      }

        .card-img {
          width: 62px;
          height: 62px;
          background-repeat: no-repeat;
          background-size: cover;
          flex-shrink: 0;
        }
        .card-header {
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          color: #3a434d;
          border-bottom: 1px solid #d5d5d5;
        }
        .card-content {
          margin-top: 9px;
          margin-bottom: 9px;
          width: 100%;
          display: flex;

          .card-content-img {
            flex-shrink: 0;
            border: 0 solid #e6e7eb;
            width: 62px;
            height: 62px;
            margin-right: 8px;
            background-size: 62px 62px;
          }
          .card-content-desc {
            flex: 1 1;
            flex-shrink: 0;
            line-height: 20px;
            overflow: hidden;

            .card-content-desc-title{
              max-height: 30px;
              font-size: 12px;
              line-height: 14px;
              color: #3a434d;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .card-content-desc-price{
              margin-top: 5px;
              font-size: 16px;
              color: #ff3d00;
              font-weight: 500;
            }
            .card-content-desc-oldprice{
              margin-top: 3px;
              font-size: 12px;
              line-height: 12px;

              .card-content-desc-old{
                text-decoration: line-through;
              }
              .card-content-desc-discount{
                min-width: 20px;
                margin-left: 6px;
                display: inline-block;
                color: #999;
              }
            }

          }
        }
        .card-footer {
          border-top: 1px solid #eff2fa;
          padding: 5px 0;
          width: 100%;
          display: flex;

          .btn {
            background: #eff5f7;
            border-radius: 4px;
            height: 24px;
            line-height: 24px;
            padding: 0 10px;
            font-size: 12px;
            border: none;
            outline: none;
            cursor: pointer;
          }
        }
        .card-footer.right {
          justify-content: flex-end;
        }

      &:after {
        display: none;
      }
    }

  }
}

.im-chat-footer {
  border-top: 1px solid $color-gray;
  height: 20rem;
  display: flex;
  flex-direction: column;

  .im-chat-tool {
    padding: 0.5rem 1rem;
    height: 3.4rem;
    position: relative;

    i {
      font-size: 2.4rem;
      cursor: pointer;
      margin-left: 1rem;
    }

    .faces-box {
      position: absolute;
      bottom: 3.8rem;
    }

    .ivu-upload {
      display: inline-block;
    }

    .history-message-btn {
      float: right;
    }
  }

  textarea {
    border: 0;
    padding: 0.5rem;
    width: 100%;
    flex: 1;
    resize: none;
    background-color: $color-box-bg !important;

    &:focus {
      border: 0;
    }
  }

  .im-chat-send {
    height: 4rem;
    text-align: right;
    padding: 0 1rem 1rem 0;
  }
}

.ivu-scroll-wrapper {
  margin: 0 !important;
}


.chat-shade {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  overflow: hidden;

  .portal-bg {
    display: flex;
    align-items: center;
    position: relative;
    padding-top: 10%;
    flex-direction: column;
    flex-grow: 1;

    .portal-text {
      color: #4f566a;
      font-family: Roboto;
      text-align: center;
      font-size: 120%;
      min-width: 500px;

      h3 {
        line-height: 30px;
        font-size: 150%;
        font-weight: 700;
      }
      p {
        font-size: inherit;
        line-height: 22px;
        font-weight: 400;
      }
    }
    .portal-image {
      margin-top: 32px;
      padding: 24px 32px;
      background-color: #fff;
      border-radius: 12px;

      img {
        width: 600px;
      }
    }
  }
}

/* 重新覆盖iview 里面的 model 小于768px 时候 宽度变100% 的问题 */
@media (max-width: 768px) {
  .user-model {
    .ivu-modal {
      width: 30rem !important;
      margin: 0 auto;
    }
  }
}

.history-message {
  width: 80%;
  height: calc(100% - 30px);
}

.page {
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 0.5rem;
}

.ivu-drawer-body {
  padding: 0 !important;

  .messages {
    height: calc(100% - 3rem);
  }
}

.model-footer {
  text-align: right;
  margin: 10px;
}

.next-box {
  display: flex;
}
</style>
